<template>
  <div class="link" >
    <a :href="$fetch.createUrl(`/bookmarks/${bookmarkId}/visit`)">
      <slot></slot>
    </a>
  </div>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'LinkCount',
  props: ['bookmarkId', 'link'],
  components: {}
})
class LinkCount extends Vue {
  @Prop bookmarkId
  @Prop link


}

export default LinkCount
</script>
